import React, { useState, useEffect, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import moment from 'moment';
import MarkerClusterer from '@google/markerclusterer';
import { Line, Scatter } from 'react-chartjs-2';
// import Chart from 'chartjs';
import { useHistory } from 'react-router';
import Table from '../../components/Table';
import useApi from '../../api/useApi';
import Traceabilty from '../../components/Traceability';
import MapComponent from '../../components/MapComponent';
import CumulativeInventory from '../../components/CumulativeInventory';

function Dashboard() {
  const hrsbtn = useRef(null);
  const daybtn = useRef(null);
  const weekbtn = useRef(null);
  const monthbtn = useRef(null);
  const myChart = useRef();
  const [getTimeStream, setStream] = useApi();
  const [_sensorData, setSensorData] = useState();
  const [recentData, setRecentData] = useApi();
  const [locationData, setLocationData] = useApi();
  const [eventData, setEventData] = useApi();
  const [timeInterval, setTimeInterval] = useState();
  const [scatterChart, setScatterChart] = useState(false);
  const [analyticsType, setAnalyticsType] = useState('tm');
  const [eventsFlag, setEventsFlag] = useState(false);
  const [timeFlag, setTimeFlag] = useState(false);
  const [view, setView] = useState(false);
  const [traceability, setTraceability] = useState(false);
  const [mapType, setMapType] = useState(false);
  const [bin, setBin] = useState(false);
  const [showInventory, setShowInventory] = useState(false);
  const [binInterval, setBinInterval] = useState(60);
  const [tempType, setTempType] = useState('C');
  const [bitValue, setBitValue] = useState({
    movement: [{ x: '', y: '' }],
    open: [],
    close: [],
    shock: [],
    reboot: [],
  });
  const [prevId, setPrevId] = useState({ id: '', type: '', period: '' });
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([]);
  const [insight, setDeviceType] = useState({
    assetId: '',
    deviceId: '',
  });
  const [deviceTypeSelected, setDevice] = useState('');
  let _id;
  const [time, setTime] = useState();

  const [analytics, setAnalytics] = useState('temperature');
  const [analyticsTime, setAnalyticsTime] = useState(1440);
  const [gmap, setMaps] = useState(false);
  const [zoom, setZoom] = useState(11);
  const [loader, setLoader] = useState(false);
  const [analyticsStats, setAnalyticsStats] = useState([]);
  const [scatteredChartData, setScatteredChartData] = useState();

  let tmLength = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  let maxValue;
  let minVal;
  if (_sensorData?.binned_time) {
    const timeStreamInterval = _sensorData?.binned_time;
    tmLength = timeStreamInterval.map((x) => {
      const date = new Date(x);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const period = `${date.getHours()}:${date.getMinutes()}-`;
      return `${period}${month}/${day}`;
    });

    maxValue = timeStreamInterval.map((x) => _sensorData?.maxValue && _sensorData?.maxValue);
    minVal = timeStreamInterval.map((x) => _sensorData?.minValue && _sensorData?.minValue);
  }

  let tmData = [];
  if (_sensorData?.[analyticsType]) {
    const temp = _sensorData?.[analyticsType].map((x) => parseFloat(x).toFixed(2));
    tmData = temp.map((x) => {
      if (isNaN(parseFloat(x))) {
        return null;
      }
      return x;
    });
  }

  // if()

  const rand = () => Math.round(Math.random() * 20 - 10);
  const yLabels =
    eventData?.data?.deviceType === 'CATM1_TAG'
      ? {
          2: 'movement',
          4: 'open',
          6: 'close',
          8: 'shock',
          10: 'reboot',
        }
      : {
          2: 'Button Press',
          4: 'Cumulative Temp',
          6: 'High Temp',
          8: 'Low Temp',
          10: 'Light On',
          12: 'Light Off',
          14: 'Reset',
        };

  useEffect(() => {
    if (!scatterChart && analyticsType === 'evt') {
      setAnalyticsType('tm');
      getAnalyticsData(insight.deviceId, analyticsType);
    }
  }, [scatterChart]);

  let _time = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  if (eventData.data !== null && eventData.data.events.timestamp.length !== 0) {
    const timeStreamInterval1 = eventData.data.events.timestamp;
    _time = timeStreamInterval1.map((x) => {
      const date = new Date(x);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const period = `${date.getHours()}:${date.getMinutes()}-`;
      return `${period}${month}/${day}`;
    });
  }
  const options = {
    maintainAspectRatio: false,
    response: true,
    legend: {
      display: false,
    },
    tooltips: {
      callbacks: {
        label(tooltipItem, data) {
          // var label = data.datasets[tooltipItem.datasetIndex].label;
          let xlabelVal = new Date(tooltipItem.xLabel).toISOString().split('T');
          xlabelVal = `${xlabelVal[0]}:${xlabelVal[1].split('.')[0]}`;
          return `(${new Date(tooltipItem.xLabel).toISOString().split('T')[0]}:${
            new Date(tooltipItem.xLabel).toISOString().split('T')[1].split('.')[0]
          }, ${yLabels[tooltipItem.yLabel]})`;
        },
      },
    },
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: false,
            callback(value, index, values) {
              return _time[index];
            },
          },
        },
      ],
      yAxes: [
        {
          ticks: {
            beginAtZero: false,
            callback(value, index, values) {
              return yLabels[value];
            },
          },
        },
      ],
    },
  };
  const ctx = document.getElementById('myChart');
  const myChart2 = new Chart(ctx, {
    type: 'line',
    plugins: [
      {
        beforeDraw: (chart) => {
          const { ctx } = chart.chart;
          ctx.save();
          const xAxis = chart.scales['x-axis-0'];
          const yAxis = chart.scales['y-axis-0'];
          const dataset = chart.data.datasets[0];
          let valueFrom = null;
          let valueFromIndex = 0;
          let xFrom = null;
          let yFrom = null;
          ctx.strokeStyle = dataset.borderColor;
          dataset.data.forEach((value, index) => {
            if (value !== null) {
              const x = xAxis.getPixelForTick(index);
              const y = yAxis.getPixelForValue(value);
              if (valueFrom != null) {
                ctx.lineWidth = dataset.borderWidth;
                if (index - valueFromIndex > 1) {
                  ctx.setLineDash([6, 6]);
                  ctx.strokeStyle = 'rgb(255, 99, 132';
                } else {
                  ctx.setLineDash([]);
                  ctx.strokeStyle = dataset.borderColor;
                }
                ctx.beginPath();
                ctx.moveTo(xFrom, yFrom);
                ctx.lineTo(x, y);
                ctx.stroke();
              }
              valueFrom = value;
              valueFromIndex = index;
              xFrom = x;
              yFrom = y;
            }
          });
          ctx.restore();
        },
      },
    ],
    data: {
      labels: analyticsType && tmLength,
      datasets: [
        {
          label: '',
          fill: false,
          lineTension: 0.2,
          backgroundColor: 'transparent',
          borderCapStyle: 'butt',
          borderColor: '#00CCFF',
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 3,
          pointHitRadius: 0,
          data: _sensorData?.[analyticsType],
          showLine: false,
        },
        {
          label: '',
          fill: false,
          lineTension: 0.1,
          borderColor: 'orange',
          borderDash: [3, 3],
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBorderWidth: 0,
          pointRadius: 0,
          pointHitRadius: 0,
          borderWidth: 1,
          pointStyle: 'rectRot',
          data: minVal,
          // showLine: true,
        },
        {
          label: '',
          fill: false,
          lineTension: 0.1,
          borderColor: 'red',
          borderDash: [3, 3],
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBorderWidth: 0,
          pointRadius: 0,
          pointHitRadius: 0,
          borderWidth: 1,
          pointStyle: 'rectRot',
          data: maxValue,
          // showLine: true,
        },
      ],
    },
    options: {
      animation: {
        duration: 0,
      },
      maintainAspectRatio: false,
      response: true,
      events: [],
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
          labels: {
            padding: 100,
          },
        },
      },
      legend: {
        display: false,
        labels: {
          padding: 100,
        },
      },
      scales: {
        stacked: true,
        xAxes: [
          {
            ticks: {
              display: true,
              tickWidth: '5px',
              padding: 10,
            },
            gridLines: {
              display: true,
              drawBorder: true,
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              display: true,
              tickWidth: '5px',
              padding: 10,
            },
            gridLines: {
              display: true,
              drawBorder: true,
            },
          },
        ],
      },
    },
  });

  const itemsss = ['tm', 'prs', 'h', 'vbat', 'ts', 'rssi', 'prb', 'torDevice'];

  const mapView = (id) => {
    setView(id);
  };

  const getTimeStreamData = (id) => {
    setTimeFlag(false);
    _id = id;
    if (id !== prevId.id) {
      setRecentData(`/device/${id}/recentData`, 'GET');
      setLocationData(`/device/${id}/locationData?t=1440`, 'GET');
      setStream(`/device/${id}/sensorData?t=1440&type=tm&scale=${tempType}`, 'GET');
    }
    // clearInterval(timeInterval);
    // setTimeInterval(
    //   setInterval(() => {
    //     setRecentData(`/device/${id}/recentData`, 'GET');
    //   }, 60000)
    // );
  };

  useEffect(() => {
    if (!eventData.isLoading && !eventData.isError && eventData.data) {
      if (eventData.data.deviceType === 'BLE_TAG') {
        const buttonPress = eventData.data.events.buttonPress.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 2,
            };
          }
        });

        const cumulativeTempAlert = eventData.data.events.cumulativeTempAlert.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 4,
            };
          }
        });

        const highTempAlert = eventData.data.events.highTempAlert.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 6,
            };
          }
        });

        const lightOff = eventData.data.events.lightOff.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 8,
            };
          }
        });

        const lightOn = eventData.data.events.lightOn.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 10,
            };
          }
        });

        const lowTempAlert = eventData.data.events.lowTempAlert.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 12,
            };
          }
        });

        const reset = eventData.data.events.reset.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 14,
            };
          }
        });

        setBitValue({
          buttonPress,
          cumulativeTempAlert,
          highTempAlert,
          lightOff,
          lightOn,
          lowTempAlert,
          reset,
        });
      } else {
        const movement = eventData.data.events.movement.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 2,
            };
          }
        });
        const open = eventData.data.events.open.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 4,
            };
          }
        });
        const close = eventData.data.events.close.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 6,
            };
          }
        });
        const shock = eventData.data.events.shock.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 8,
            };
          }
        });
        const reboot = eventData.data.events.reboot.map((x, i) => {
          if (x) {
            return {
              x: new Date(moment(eventData.data.events.timestamp[i])),
              y: 10,
            };
          }
        });

        setBitValue({
          movement,
          open,
          close,
          shock,
          reboot,
        });
      }
      setLoader(false);
    }
  }, [eventData.isLoading, eventData.isError, eventData.data]);

  useEffect(() => {
    let x;
    if (bitValue.movement) {
      x = {
        datasets: [
          {
            label: 'movement',
            data: bitValue.movement,
            backgroundColor: 'black',
          },
          {
            label: 'open',
            data: bitValue.open,
            backgroundColor: 'red',
          },
          {
            label: 'close',
            data: bitValue.close,
            backgroundColor: 'blue',
          },
          {
            label: 'shock',
            data: bitValue.shock,
            backgroundColor: 'pink',
          },
          {
            label: 'reboot',
            data: bitValue.reboot,
            backgroundColor: 'grey',
          },
        ],
      };
    } else {
      x = {
        datasets: [
          {
            label: 'Button Press',
            data: bitValue.buttonPress,
            backgroundColor: 'black',
          },
          {
            label: 'Cumulative Temp',
            data: bitValue.cumulativeTempAlert,
            backgroundColor: 'red',
          },
          {
            label: 'High Temp',
            data: bitValue.highTempAlert,
            backgroundColor: 'blue',
          },
          {
            label: 'Low Temp',
            data: bitValue.lowTempAlert,
            backgroundColor: 'pink',
          },
          {
            label: 'Light On',
            data: bitValue.lightOn,
            backgroundColor: 'green',
          },
          {
            label: 'Light Off',
            data: bitValue.lightOff,
            backgroundColor: 'grey',
          },
          {
            label: 'Reset',
            data: bitValue.reset,
            backgroundColor: 'yellow',
          },
        ],
      };
    }
    setScatteredChartData(x);
  }, [bitValue]);

  // sensorData response
  useEffect(() => {
    if (!getTimeStream.isLoading && !getTimeStream.isError && getTimeStream.data) {
      setLoader(false);
      if (getTimeStream.data && getTimeStream.data.data && getTimeStream.data.data.hasOwnProperty('torValue')) {
        const _torArr = getTimeStream.data.data[analyticsType].map((x) => parseFloat(x).toFixed(2) * 0.5);
        getTimeStream.data.data[analyticsType] = _torArr;
      }

      if (getTimeStream.data && getTimeStream.data.data && getTimeStream.data.data.hasOwnProperty('tm')) {
        const modifiedTemp = getTimeStream.data.data['tm'].map((x) => getTemp(x));
        getTimeStream.data.data['tm'] = modifiedTemp;
      }

      setSensorData(getTimeStream.data.data);
    }
  }, [getTimeStream.isLoading, getTimeStream.isError, getTimeStream.data]);

  const getTemp = (temp) => {
    if (!temp) return null;
    let x = temp;
    if (x >= 256 && x <= 512) {
      x = x - 512.0;
    }
    return parseFloat(x).toFixed(2);
  };

  useEffect(() => {
    if (!recentData.isLoading && !recentData.isError && recentData.data) {
      const gs = [];
      if (recentData.data) {
        if (recentData?.data?.response?.hasOwnProperty('evnts')) setEventsFlag(true);
        else setEventsFlag(false);
        if (recentData?.data?.response?.hasOwnProperty('ts')) {
          let recentTimestamp = recentData?.data?.response?.ts;
          if (recentTimestamp > 9999999999) {
            recentTimestamp /= 1000;
          }
          const timeNow = new Date().getTime() / 1000;
          let sec = Math.ceil(timeNow - recentTimestamp);
          let day = Math.floor(sec / 86400);
          day >= 1 ? (sec -= day * 86400) : (day = '00');
          let hours = Math.floor(sec / 3600);
          hours >= 1 ? (sec -= hours * 3600) : (hours = '00');
          let min = Math.floor(sec / 60);
          min >= 1 ? (sec -= min * 60) : (min = '00');
          sec < 1 ? (sec = '00') : void 0;

          min.toString().length == 1 ? (min = `0${min}`) : void 0;
          sec.toString().length == 1 ? (sec = `0${sec}`) : void 0;
        }
        itemsss.filter((x) => {
          if (recentData?.data?.response?.hasOwnProperty(x)) {
            if (recentData?.data?.response?.torDevice !== 0 || x !== 'torDevice') {
              gs.push(x);
            }
          }
        });
        setAnalyticsStats(gs);
        setLoader(false);
      }
    }
  }, [recentData.isLoading, recentData.isError, recentData.data]);

  useEffect(() => {
    const i = 0;
    let _lat = 0;
    let _lng = 0;
    // setCoordinates([]);
    if (!locationData.isLoading && !locationData.isError && locationData.data) {
      if (
        locationData?.data?.response?.data?.lat &&
        locationData?.data?.response?.data?.lng &&
        locationData?.data?.response?.data?.lat.length > 0
      ) {
        const latdata = locationData?.data?.response?.data?.lat.reverse();
        const lngdata = locationData?.data?.response?.data?.lng.reverse();
        const coor = latdata.map((x, key) => {
          return {
            lat: parseFloat(x),
            lng: parseFloat(lngdata[key]),
          };
        });
        if (coordinates !== coor) {
          // setCoordinates([]);
          _lat = parseFloat(locationData?.data?.response?.data?.lat[i]);
          _lng = parseFloat(locationData?.data?.response?.data?.lng[i]);
          setCenter({ lat: _lat, lng: _lng });
          setCoordinates(() => coor);
        }
      } else {
        setCenter({
          lat: 32.874525,
          lng: -117.2160221,
        });
        setCoordinates([]);
      }
      setTimeFlag(true);
    }
  }, [locationData.isLoading, locationData.isError, locationData.data]);

  const showMaps = (res) => {
    setScatterChart(false);
    setAnalyticsStats([]);
    setAnalytics('temperature');
    setCoordinates([]);
    // setTime("");
    setDeviceType({
      assetId: '',
      deviceId: '',
    });
    setMaps(res);
    setLoader(res);
  };

  const deviceType = (astId, dvcId) => {
    getTimeStream.data = null;
    clearInterval(timeInterval);
    setAnalyticsTime(1440);
    setAnalyticsType('tm');
    setDeviceType({
      assetId: astId,
      deviceId: dvcId,
    });
    setPrevId({ id: '', type: '', period: '' });
  };

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,
      maxZoom: 18,

      mapTypeControl: true,
      // mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    const bounds = new maps.LatLngBounds();
    places.forEach((place, idx) => {
      // const svgMarker = {
      //   path:
      //     'm12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z',
      //   fillColor: 'red',
      //   fillOpacity: 1,
      //   strokeWeight: 0,
      //   rotation: 0,
      //   scale: 1,
      //   anchor: new maps.Point(15, 30),
      // };
      // console.log("locationData?.data?.response?.data?.ts[idx]",locationData?.data?.response?.data?.ts);
      let _date;
      if (places.length === locationData?.data?.response?.data?.ts.length) {
        if (locationData?.data?.response?.data?.ts[idx] > 9999999999) {
          _date = locationData?.data?.response?.data?.ts[idx];
        } else {
          _date = locationData?.data?.response?.data?.ts[idx] * 1000;
        }
      } else if (locationData?.data?.response?.ts > 9999999999) {
        _date = locationData?.data?.response?.ts;
      } else {
        _date = locationData?.data?.response?.ts * 1000;
      }
      markers.push(
        new maps.Marker({
          position: {
            lat: parseFloat(place.lat),
            lng: parseFloat(place.lng),
          },
          icon: 'assets/img/marker.svg',
          map,
          title: `${new Date(_date).toISOString().split('T')[0]}, ${place.lat}, ${place.lng}`,
          // title: `(${new Date(_date).toISOString().split('T')[0]}:${new Date(_date).toISOString().split('T')[1].split('.')[0]}, ${place.lat}, ${place.lng})`
        })
      );
      bounds.extend(place);
    });
    map.fitBounds(bounds);
    bounds.getCenter();

    const markerCluster = new MarkerClusterer(map, markers, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      gridSize: 20,
      minimumClusterSize: 5,
    });
    const arrow = {
      path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale: 2,
      scaledSize: new maps.Size(100, 100),
      origin: new maps.Point(0, 0), // origin
      anchor: new maps.Point(0, 0), // anchor
      strokeColor: '#01C796',
      rotation: 180,
    };

    const symbolOne = {
      path: 'M -2,0 0,-2 2,0 0,2 z',
      strokeColor: '#F00',
      fillColor: '#F00',
      fillOpacity: 1,
    };

    const symbolThree = {
      path: 'M -2,-2 2,2 M 2,-2 -2,2',
      strokeColor: '#292',
      strokeWeight: 1,
    };
    const newLines = [];
    for (let i = 0; i < places.length - 1; i++) {
      const line = new maps.Polyline({
        path: places.slice(i, i + 2),
        strokeColor: '#00CCFF',
        strokeWidth: 1,
        strokeWeight: 1,
        icons: [
          {
            icon: symbolOne,
            offset: '0%',
          },
          {
            icon: arrow,
            offset: '50%',
          },
          {
            icon: symbolThree,
            offset: '100%',
          },
        ],
      });
      line.setMap(map);
      newLines.push(line);
    }

    // const symbolOne = {
    //   path: 'M -2,0 0,-2 2,0 0,2 z',
    //   strokeColor: '#F00',
    //   fillColor: '#F00',
    //   fillOpacity: 1,
    // };

    // const symbolThree = {
    //   path: 'M -2,-2 2,2 M 2,-2 -2,2',
    //   strokeColor: '#292',
    //   strokeWeight: 1,
    // };

    // const symbolTwo = {
    //   path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
    //   scale: 2,
    //   scaledSize: new maps.Size(100, 100),
    //   origin: new maps.Point(0, 0), // origin
    //   anchor: new maps.Point(0, 0), // anchor
    //   strokeColor: 'red',
    //   rotation: 180,
    // };

    // const routePolyline = new maps.Polyline({
    //   path: places,
    //   icons: [
    //     {
    //       icon: symbolOne,
    //       offset: '0%',
    //     },
    //     {
    //       icon: symbolTwo,
    //       offset: '50%',
    //     },
    //     {
    //       icon: symbolThree,
    //       offset: '100%',
    //     },
    //   ],
    //   strokeColor: '#00CCFF',
    //   strokeWidth: 1,
    //   strokeWeight: 1,
    // });
    // routePolyline.setMap(map);
  };

  const getAnalyticsData = (_deviceId, type) => {
    const deviceId = _deviceId;
    setLoader(true);
    if (myChart2 !== undefined) {
      while (myChart2.data.datasets.length > 0) {
        myChart2.data.datasets.pop();
      }
    }
    if (type === prevId.type && analyticsTime !== prevId.period) {
      setPrevId({ type });
      if (type === 'evt') {
        setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
      } else {
        setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}&scale=${tempType}`, 'GET');
      }
      if (mapType) {
        if (bin) {
          setLocationData(
            `/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS&binInterval=${binInterval}`,
            'GET'
          );
        } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS`, 'GET');
      } else if (bin) {
        setLocationData(
          `/device/${insight.deviceId}/locationData?t=${analyticsTime}&binInterval=${binInterval}`,
          'GET'
        );
      } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}`, 'GET');
    }
    if (type !== prevId.type && analyticsTime !== prevId.period) {
      setPrevId({ type });
      if (type === 'evt') {
        setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
      } else {
        setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}&scale=${tempType}`, 'GET');
      }
      if (mapType) {
        if (bin) {
          setLocationData(
            `/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS&binInterval=${binInterval}`,
            'GET'
          );
        } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS`, 'GET');
      } else if (bin) {
        setLocationData(
          `/device/${insight.deviceId}/locationData?t=${analyticsTime}&binInterval=${binInterval}`,
          'GET'
        );
      } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}`, 'GET');
    }
    // clearInterval(timeInterval);
    // setTimeInterval(
    //   setInterval(() => {
    //     if (type === 'evt') {
    //       setEventData(`/device/${deviceId}/eventData?t=${analyticsTime}`, 'GET');
    //     } else {
    //       setStream(`/device/${deviceId}/sensorData?t=${analyticsTime}&type=${type}`, 'GET');
    //     }
    //   }, 60000)
    // );
  };

  const handleDeviceType = (x) => {
    setDevice(x);
    setMapType(false);
  };

  const toggleTraceability = () => {
    setTraceability((prev) => !prev);
  };

  useEffect(() => {
    if (gmap) {
      getAnalyticsData(insight.deviceId, analyticsType);
    }
    // action on update of movies
  }, [analyticsTime]);

  const handleMapType = (x) => {
    setMapType(x);
  };

  const handleBin = (x) => {
    setBin(x);
  };

  const lastReportedAt = (x) => {
    // alert(x)
    setTime(x);
  };

  useEffect(() => {
    if (insight.deviceId)
      if (mapType) {
        if (bin) {
          setLocationData(
            `/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS&binInterval=${binInterval}`,
            'GET'
          );
        } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}&type=GPS`, 'GET');
      } else if (bin) {
        setLocationData(
          `/device/${insight.deviceId}/locationData?t=${analyticsTime}&binInterval=${binInterval}`,
          'GET'
        );
      } else setLocationData(`/device/${insight.deviceId}/locationData?t=${analyticsTime}`, 'GET');
  }, [mapType, bin]);

  return (
    <>
     {!showInventory && <div
        className="mt-10 h-full bg-white mx-auto overflow-auto phone_font dash_ui relative"
        style={{
          width: traceability ? '75%' : '78%',
          height: view && '92vh',
        }}
      >
        {!traceability && (
          <>
            {' '}
            <Table
              getTimeStreamData={getTimeStreamData}
              showMap={showMaps}
              height={gmap}
              deviceType={deviceType}
              handleDeviceType={handleDeviceType}
              mapView={mapView}
              tempType={tempType}
              setTempType={setTempType}
              lastReportedAt={lastReportedAt}
              setShowInventory={setShowInventory}
            />
            {!view && (
              <div
                className={gmap ? 'insightBarOpen' : 'insightBar'}
                style={{ top: gmap && '50%', bottom: gmap && '3%' }}
              >
                <div
                  className="map_resp w-full px-5 h-8 xl:h-9 text-white text-xs font-medium bg-btnBg flex items-center"
                  onDoubleClick={() => {
                    if (insight.deviceId) {
                      setMaps(!gmap);
                    }
                    setCenter({ lat: 32.874525, lng: -117.2160221 });
                    setAnalytics('');
                  }}
                >
                  <p className="lg:uppercase phone-font">
                    {insight.assetId ? `${insight.assetId} (${insight.deviceId}) ` : ''}
                    <span className="text-xs ml-7 phone-font">
                      {analyticsStats.includes('h') ||
                      analyticsStats.includes('tm') ||
                      analyticsStats.includes('prs') ||
                      analyticsStats.includes('prb') ||
                      analyticsStats.includes('vbat') ||
                      analyticsStats.includes('rssi')
                        ? `${time}`
                        : ''}
                    </span>
                  </p>
                  {!analyticsStats.includes('vbat') ? (
                    ''
                  ) : (
                    <div className="flex ml-7 phone-font1">
                      {recentData?.data?.response?.vbat !== null ? (
                        <>
                          <img
                            src="assets/img/Battery.png"
                            className="w-4 mr-2 phone_font1 transform -rotate-90 phone-font"
                            alt=""
                          />
                          {recentData?.data?.response?.vbat}mV
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  {!analyticsStats.includes('rssi') ? (
                    ''
                  ) : (
                    <div className="flex ml-7 phone-font1">
                      {recentData?.data?.response?.rssi !== null ? (
                        <>
                          <img src="assets/img/Antenna.png" className="w-4 mr-2 phone-font1" alt="" />
                          {recentData?.data?.response?.rssi}dBm
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                  )}
                  {insight.deviceId !== '' && (
                    <button
                      className="trace bg-lightBlu text-white py-1 px-4 text-xs focus:outline-none hover:border-indigo-400 focus-within:border-indigo-400 mx-auto phone_font"
                      onClick={() => setTraceability(true)}
                    >
                      {' '}
                      {window.screen.availHeight < 800 && window.screen.availWidth > 300 ? 'Trace' : 'Trace Asset'}
                    </button>
                  )}
                  {/* } */}
                  <img
                    src="assets/img/Arrow.svg"
                    className={`w-3.5 mr-2 ml-auto cursor-pointer ${
                      gmap ? `h-6 transform rotate-90` : `h-tableHeight`
                    }`}
                    onClick={() => {
                      if (insight.deviceId) {
                        setMaps(!gmap);
                      }
                      setCenter({ lat: 32.874525, lng: -117.2160221 });
                      setAnalytics('');
                    }}
                    alt=""
                  />
                </div>

                {gmap ? (
                  <div className="flex bg-white relative top-0 left-0 right-0 bottom-0 rounded-b-md p-3 map_width">
                    <div className="w-7/12 mx-3 relative flex flex-col overflow-auto">
                      {!loader &&
                        !analyticsStats.includes('h') &&
                        !analyticsStats.includes('tm') &&
                        !analyticsStats.includes('prb') &&
                        !analyticsStats.includes('torDevice') &&
                        !analyticsStats.includes('prs') && (
                          <div className=" w-full py-3 left-10 z-50" alt="">
                            NO SENSOR DATA AVAILABLE
                          </div>
                        )}
                      {loader && (
                        <img
                          src="assets/img/loader.svg"
                          className="absolute top-1/4 left-2/4 w-16 "
                          alt=""
                          style={{ zIndex: '19999999' }}
                        />
                      )}
                      <div className="flex w-full -mt-1 items-center">
                        {analyticsStats.includes('tm') && (
                          <button
                            className={`flex items-center h-9 px-1 m-1
                    text-center border-2 ${
                      analyticsType === 'tm' ? 'bg-btnBg text-white' : ''
                    } rounded-lg focus:outline-none hover:border-indigo-400 focus-within:border-indigo-400`}
                            onClick={() => {
                              setAnalytics('temperature');
                              setAnalyticsType('tm');
                              getAnalyticsData(insight.deviceId, 'tm');
                              setScatterChart(false);
                            }}
                          >
                            {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.tm[0])}`}
                      &#8451;
                    </span> */}
                            <img
                              src={analyticsType === 'tm' ? 'assets/img/temp-white.svg' : 'assets/img/temp-grey.svg'}
                              className="w-3 mx-1"
                              alt=""
                            />
                            <span className="text-xs mr-1">TEMP</span>
                          </button>
                        )}
                        {analyticsStats.includes('h') && (
                          <button
                            className={`flex items-center h-9 px-1 m-1
                     border-2 rounded-lg ${
                       analyticsType === 'h' ? 'bg-btnBg text-white' : ''
                     } focus:outline-none hover:border-indigo-400 focus-within:border-indigo-400`}
                            onClick={() => {
                              setAnalyticsType(() => 'h');
                              setAnalytics('humidity');
                              getAnalyticsData(insight.deviceId, 'h');
                              setScatterChart(false);
                            }}
                          >
                            {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.h[0])}%`}
                    </span> */}
                            <img
                              src={
                                analyticsType === 'h' ? 'assets/img/humidity-white.svg' : 'assets/img/humidity-grey.svg'
                              }
                              className="w-3.5 mx-1"
                              alt=""
                            />
                            <span className="text-xs mr-1">HUM</span>
                          </button>
                        )}
                        {analyticsStats.includes('prs') && (
                          <button
                            className={`flex items-center h-9 px-1 m-1
                    text-center border-2 ${
                      analyticsType === 'prs' ? 'bg-btnBg text-white' : ''
                    } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                            onClick={() => {
                              setAnalytics('pressure');
                              setAnalyticsType('prs');
                              getAnalyticsData(insight.deviceId, 'prs');
                              setScatterChart(false);
                            }}
                          >
                            {/* <span className="float-right text-md mx-2 mt-1">
                      {`${Math.floor(recentData?.data?.response?.data?.prs[0])}`}
                    </span> */}
                            <img
                              src={
                                analyticsType === 'prs'
                                  ? 'assets/img/pressure-white.svg'
                                  : 'assets/img/pressure-grey.svg'
                              }
                              className="w-4 mx-1"
                              alt=""
                            />
                            <span className="text-xs mr-1">PRES</span>
                          </button>
                        )}
                        {analyticsStats.includes('prb') && (
                          <button
                            className={`flex items-center h-9 px-1 m-1 text-center border-2 ${
                              analyticsType === 'prb' ? 'bg-btnBg text-white' : ''
                            } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                            onClick={() => {
                              setAnalytics('cryo');
                              setAnalyticsType('prb');
                              getAnalyticsData(insight.deviceId, 'prb');
                              setScatterChart(false);
                            }}
                          >
                            {/* <span className="float-right text-md mx-2 mt-1 ">
                      {`${Math.floor(recentData?.data?.response?.data?.prb[0])}`}
                      &#8451;
                    </span> */}
                            <img
                              src={analyticsType === 'prb' ? 'assets/img/probe-white.svg' : 'assets/img/probe-grey.svg'}
                              className="w-4 mx-1"
                              alt=""
                            />
                            <span className="text-xs mr-1">PROB</span>
                          </button>
                        )}
                        {analyticsStats.includes('torDevice') && (
                          <button
                            className={`flex items-center h-9 px-1 m-1 text-center border-2 ${
                              analyticsType === 'torValue' ? 'bg-btnBg text-white' : ''
                            } focus:outline-none rounded-lg hover:border-indigo-400 focus-within:border-indigo-400`}
                            onClick={() => {
                              setAnalytics('tor');
                              setAnalyticsType('torValue');
                              getAnalyticsData(insight.deviceId, 'torValue');
                              setScatterChart(false);
                            }}
                          >
                            {/* <span className="float-right text-md mx-2 mt-1 ">
                      {`${Math.floor(recentData?.data?.response?.data?.prb[0])}`}
                      &#8451;
                    </span> */}
                            <img
                              src={
                                analyticsType === 'torValue'
                                  ? 'assets/img/probe-white.svg'
                                  : 'assets/img/probe-grey.svg'
                              }
                              className="w-4 mx-1"
                              alt=""
                            />
                            <span className="text-xs mr-1">TOR</span>
                          </button>
                        )}
                        {eventsFlag && timeFlag && (
                          <button
                            type="submit"
                            className={` px-4 py-1 text-xs m-1 ml-auto border ${
                              analyticsType === 'evt' ? 'border-primary' : ''
                            } focus:outline-none rounded-3xl hover:border-primary focus-within:border-primary`}
                            onClick={() => {
                              if (analytics !== 'event') {
                                setAnalytics('events');
                                setAnalyticsType('evt');
                                getAnalyticsData(insight.deviceId, 'evt');
                              } else {
                                setAnalytics('temperature');
                                setAnalyticsType('tm');
                                getAnalyticsData(insight.deviceId, 'tm');
                              }
                              setScatterChart(!scatterChart);
                            }}
                          >
                            Events
                          </button>
                        )}
                      </div>
                      <div className="border border-opacity-20 border-primary py-1 mt-auto ">
                        {timeFlag && (
                          <div className="flex  top-12 right-0 mx-2 uppercase justify-between float-right">
                            {/* <p className="text-role pl-2 mt-1 font-black">{analytics}</p> */}
                            <div>
                              <button
                                type="submit"
                                ref={hrsbtn}
                                className={`w-6 text-xs h-5 border-r-2 ${
                                  analyticsTime === 180 ? 'bg-btnBg text-white' : ''
                                } focus:outline-none`}
                                onClick={() => {
                                  setZoom(14);
                                  setAnalyticsTime(180);
                                  setBinInterval(15);
                                }}
                              >
                                3H
                              </button>
                              <button
                                ref={daybtn}
                                type="submit"
                                className={`w-6 text-xs h-5 border-r-2 ${
                                  analyticsTime === 1440 ? 'bg-btnBg text-white' : ''
                                } focus:outline-none`}
                                onClick={() => {
                                  setZoom(11);
                                  setAnalyticsTime(1440);
                                  setBinInterval(60);
                                }}
                              >
                                1D
                              </button>
                              <button
                                ref={weekbtn}
                                type="submit"
                                className={`w-6 text-xs h-5 border-r-2 ${
                                  analyticsTime === 10080 ? 'bg-btnBg text-white' : ''
                                } focus:outline-none`}
                                onClick={() => {
                                  setZoom(6);
                                  setAnalyticsTime(10080);
                                  setBinInterval(180);
                                }}
                              >
                                1W
                              </button>
                              <button
                                ref={monthbtn}
                                type="submit"
                                className={`w-6 text-xs h-5 ${
                                  analyticsTime === 43200 ? 'bg-btnBg text-white' : ''
                                } focus:outline-none hover:border-indigo-400`}
                                onClick={() => {
                                  setZoom(0);
                                  setAnalyticsTime(43200);
                                  setBinInterval(1440);
                                }}
                              >
                                1M
                              </button>
                            </div>
                          </div>
                        )}

                        <div className="w-full px-3 overflow-hidden">
                          {/* <div className=" left-0 right-0"> */}
                          <div className="dash_hw pb-4">
                            {!scatterChart && <canvas id="myChart" ref={myChart} height={100} />}
                            {scatterChart && <Scatter data={scatteredChartData} options={options} height={100} />}
                          </div>
                          {/* <Line data={data} options={options} /> */}
                        </div>
                        {/* </div> */}
                      </div>
                    </div>
                    <div className="w-5/12 mr-2 flex flex-col items-center relative map_mob">
                      {/* <button
                    onClick={handleMapType}
                    className={`trace_mob absolute z-30 top-2 left-2 bg-white 'text-black' py-1.5 px-4 text-sm ${
                      mapType ? 'font-bold' : 'font-normal'
                    } focus:outline-none hover:bg-gray-300  phone_font border outline-none`}
                  >
                    GPS
                  </button> */}
                      <MapComponent
                        selectedPage="dashboard"
                        coordinates={coordinates}
                        center={center}
                        selectedData={locationData}
                        cluster
                        polyline
                        handleMapType={handleMapType}
                        mapType={mapType}
                        bin={bin}
                        handleBin={handleBin}
                        deviceType={deviceTypeSelected}
                      />
                      {/* <GoogleMapReact
                key={coordinates}
                bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
                options={getMapOptions}
                defaultZoom={11}
                center={center}
                onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
                yesIWantToUseGoogleMapApiInternals
              /> */}
                    </div>
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}
        {traceability && (
          <Traceabilty deviceId={insight.deviceId} assetId={insight.assetId} handleClose={toggleTraceability} />
        )}
      </div>}
      {showInventory && <CumulativeInventory handleClose={()=>setShowInventory(false)} />}
    </>
  );
}

export default Dashboard;
